'use client';
const xref = (...args)=>[
        'xref',
        ...args
    ].join('-');

export { xref };
//# sourceMappingURL=xref.js.map
